import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    Paper
} from '@material-ui/core';
import moment from "moment";
export default class ComponentToPrint extends React.Component {
    render() {
        const amendedLeafDetails = this.props.amendedLeafDetails;
        const amendedLeafTotal = this.props.amendedLeafTotal;
        const searchData = this.props.searchData;
        return (
            <div>
                <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
                <h2><center><u>Amended Leaf Details Report</u></center></h2>
                <div>&nbsp;</div>
                <h3><center>{searchData.groupName} - {searchData.factoryName}</center></h3>
                <h3><center>{searchData.routeName ? 'Route :'+ searchData.routeName : 'Route :' + 'All Routes' }</center></h3>
                <h3><center> From Date : {searchData.fromDate} - To Date :{searchData.toDate}</center></h3>
                <div>&nbsp;</div>
                
                <div>
                    {amendedLeafDetails.length > 0 ? (
                    <Box display="flex" justifyContent="flex-end" p={2}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'} style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Route</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>registration Number</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Name</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Collected Date</TableCell> 
                                        <TableCell align={'center'} style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Original Weight</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>Amended Weight</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {amendedLeafDetails.map((group, index, idx) => (
                                        <React.Fragment key={index}>

                                            <TableRow key={`${index}-${idx}`}>
                                                <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>
                                                {group.routeName}
                                                </TableCell>
                                                <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>
                                                {group.registrationNumber}
                                                </TableCell>
                                                <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>
                                                {group.name}
                                                </TableCell>
                                                <TableCell align={'center'} component="th" scope="row" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>
                                                {moment(group.collectedDate).format('YYYY-MM-DD')}
                                                </TableCell> 
                                                <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>
                                                {Number(group.originalWeight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </TableCell>
                                                <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black" ,height: "20px" ,padding: "4px"}}>
                                                {Number(group.amendedWeight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    ))}
                                        <TableRow>
                                            <TableCell colSpan={4} style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px' }} align={'center'}><b>Total</b></TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px' }}>
                                              <b>{Number(amendedLeafTotal.originalWeight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px' }}>
                                              <b>{Number(amendedLeafTotal.amendedWeight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </TableCell>
                                        </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                ) : null}
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
                </div>
            </div>
        );

    }

}
